import React, { useState } from 'react';
import * as R from 'ramda';
import { StyledTableWrapper, getUpdateDiv, tableRender } from './common';

export const columns = [
  {
    column: 'PASeq',
    label: '流水號',
    className: 'first',
  },
  {
    column: 'event_seq',
    label: '事件順序',
  },
  {
    column: 'is_offensive',
    label: '是攻方',
  },
  {
    column: 'player.name',
    label: '上場選手',
  },
  {
    column: 'position',
    label: '守位',
  },
  {
    column: 'replace.name',
    label: '下場選手',
  },
];

export const toSubstitutionList = (PAList) => {
  return R.flatten(
    PAList.map((PA, PAIndex) => {
      return PA.substitutions.map((substitution) => ({
        PASeq: PAIndex + 1,
        event_seq: substitution.event_index + 1,
        ...substitution,
      }));
    }),
  );
};

const FormalGameSubstitutions = ({ players, opponentPlayers, PAList, handleUpdate }) => {
  const [selectedRow, setSelectedRow] = useState(-1);
  const [selectColumn, setSelectColumn] = useState('');

  return (
    <div>
      {getUpdateDiv(
        toSubstitutionList(PAList),
        columns,
        setSelectedRow,
        setSelectColumn,
        selectedRow,
        selectColumn,
        handleUpdate,
        {
          pitchers: opponentPlayers,
        },
      )}
      <StyledTableWrapper>
        {tableRender(toSubstitutionList(PAList), columns, setSelectedRow, setSelectColumn, selectedRow, selectColumn)}
      </StyledTableWrapper>
    </div>
  );
};

export default FormalGameSubstitutions;
